import { uploadImageToS3 } from '@/utils/imageUtils';
import { buildCloudFrontUrl, isAbsoluteUrl } from '@/utils/pathUtils';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('OpenAIService', openAIService);

    function openAIService(blockUI, OpenAIAPIService, MultipleFileUploadService, $window, $mdDialog, $timeout) {
        function getTestingUrl(uploadPath) {
            return isAbsoluteUrl(uploadPath) ? uploadPath : buildCloudFrontUrl(uploadPath);
        }

        function setImageElementAndPersistTestingUrl(targetObject, canvas, imageB64) {
            return new Promise(function (resolve, reject) {
                const dataUrl = 'data:image/png;base64,' + imageB64;
                const img = new Image();

                img.onload = async function () {
                    try {
                        targetObject.setElement(img);
                        canvas.renderAll();
                    } catch (error) {
                        reject(error);
                        return;
                    }

                    try {
                        const uploadResponse = await uploadImageToS3('preview', dataUrl);
                        targetObject.testingUrl = getTestingUrl(uploadResponse.Path);
                    } catch (err) {
                        console.error('Failed to upload OpenAI image-to-image result to S3:', err);
                    }

                    resolve();
                };
                img.onerror = function (e) {
                    console.log(e);
                    reject(new Error('Failed to load OpenAI image-to-image result'));
                };
                img.crossOrigin = 'Anonymous';
                img.src = dataUrl;
            });
        }

        function textToImage($scope, canvas, username, textTyped) {
            const { bulkEdit, selectedObjectGroup, imageSelected } = $scope;
            const targetObjects = bulkEdit?.enabled
                ? selectedObjectGroup?._objects
                : imageSelected
                ? [imageSelected]
                : [];

            const blockUIMessage = 'Transforming your text to an image 📝✨🎨';
            blockUI.start(blockUIMessage);
            OpenAIAPIService.textToImage(username, textTyped)
                .then((response) => {
                    if (response) {
                        var imageB64 = response;
                        if (imageB64) {
                            const img = new Image();
                            img.onload = function () {
                                for (const targetObject of targetObjects) {
                                    targetObject.setElement(img);
                                }
                                canvas.renderAll();
                            };
                            img.onerror = function (e) {
                                console.log(e);
                            };
                            img.crossOrigin = 'Anonymous';
                            img.src = imageB64;
                        }
                    } else {
                        throw new Error('No image was generated. Please try again.');
                    }

                    console.log('done rendering image in placeholder, removing block UI');
                    //WTF, if I don't wrap the blockUI.stop() in a $scope.$apply it wont work :|
                    $scope.$apply(function () {
                        blockUI.stop();
                    });
                })
                .catch((error) => {
                    $window.rumReportError(error);

                    for (const targetObject of targetObjects) {
                        targetObject.oldCutoutImageFile = null;
                        targetObject.oldRBCOPImageFile = null;
                    }

                    $timeout(() => $scope.$apply());
                    blockUI.stop();

                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('We received an error from OpenAI:')
                            .textContent(error.message)
                            .ok('OK!')
                    );
                });
        }

        async function imageToImage($scope, canvas, username, image) {
            const { bulkEdit, selectedObjectGroup, imageSelected } = $scope;
            const targetObjects = bulkEdit?.enabled
                ? selectedObjectGroup?._objects || []
                : imageSelected
                ? [imageSelected]
                : [];

            if (!targetObjects.length) return;

            const blockUIMessage = 'Transforming your image 📝✨🎨';
            blockUI.start(blockUIMessage);

            try {
                await Promise.all(
                    targetObjects.map(async function (targetObject) {
                        const targetObjectConfig = targetObject.imageToImageConfig || {};
                        const response = await OpenAIAPIService.imageToImageOnBackendServer(
                            username,
                            image,
                            targetObjectConfig
                        );

                        if (response.error) {
                            throw new Error(response.error.message);
                        }

                        if (response.base64_image) {
                            await setImageElementAndPersistTestingUrl(targetObject, canvas, response.base64_image);
                        }
                    })
                );

                console.log('done rendering image in placeholder, removing block UI');
                //WTF, if I don't wrap the blockUI.stop() in a $scope.$apply it wont work :|
                $scope.$apply(function () {
                    blockUI.stop();
                });
            } catch (error) {
                $window.rumReportError(error);

                for (const targetObject of targetObjects) {
                    targetObject.oldCutoutImageFile = null;
                    targetObject.oldRBCOPImageFile = null;
                }

                $timeout(() => $scope.$apply());
                blockUI.stop();

                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('We received an error from OpenAI:')
                        .htmlContent(error.message)
                        .ok('OK!')
                );
            }
        }

        return {
            textToImage,
            imageToImage
        };
    }
})();
